module.exports = __webpack_public_path__ + "static/media/travel-booking-min.33bbf948.png";